import '../vendor/01_modernizr.min.js'
// import Headroom from '../vendor/02_headroom.min.js'
import '../vendor/03_lazysizes.min.js'
import '../vendor/04_magnific-popup.min.js'
import '../vendor/05_cssua.min.js'
import $ from 'jQuery'

/**
 * @namespace Mangrove
 * @author Mangrove
 */

const Mangrove = {

  /**
   * Initialize object
   * @function init
   * @memberof Mangrove
   */

  init() {

    this.cache();
    this.events();
    // this.initHeadroom();
    this.initPopups();
    this.initProgLoading();

  }, // init()

  /**
   * Cache reusable data
   * @function cache
   * @memberof Mangrove
   */

  cache() {

    this.$doc = $(document);
    this.$win = $(window);
    this.$html = $('html');
    this.$body = $('body');
    this.$mainWrap = $('main');
    this.$header = $('.js-header');
    this.$mobileNav = $('.js-mobile-nav');
    this.$hamburger = $('.js-hamburger');

  }, // _cache()

  /**
   * Attach event listeners
   * @function _events
   * @memberof Mangrove
   */

  events() {

    this.$doc.on(
        'click',
        '.js-hamburger',
        event => this.showMobileNav(event)
    );

    this.$doc.on(
        'click',
        '.js-share',
        event => this.openShareWindow(event)
    );

  }, // _events()

  openShareWindow(event) {
    let link = $(event.currentTarget).attr('href');
    if (link.substr(0, 6) != 'mailto') {
        event.preventDefault();
        window.open(link, '', 'width=600, height=400');
    }
  },

  initPopups() {
    $('.js-popup').magnificPopup({
      type: 'inline',
      midClick: true,
      removalDelay: 100,
      mainClass: 'popup--animate'
    });
  },

  // initHeadroom() {
  //   let theHeader = document.querySelector('.js-header');
  //   let headroom = new Headroom(theHeader);
  //   headroom.init();
  // },

  showMobileNav(event) {
    event.preventDefault();
    this.$mobileNav.toggleClass('is-active');
    this.$hamburger.toggleClass('is-active');
    if ( this.$mobileNav.hasClass('is-active') ) {
      this.$hamburger.attr("aria-pressed", "true");
    } else {
      this.$hamburger.removeAttr("aria-pressed");
    }
  },

  initProgLoading() {
    $('.progressive-image').each(function(){

        var image = new Image();
        var previewImage = $(this).find('.loadingImage');
        console.log(previewImage);
        var newImage = $(this).find('.overlay');
        console.log(newImage);

        image.onload = function(){
            newImage.css('background-image', 'url(' + image.src + ')');
            newImage.css('opacity', '1');
            console.log('complete');
        };

        image.src = previewImage.data('image');
    });
  }
}; // Mangrove

Mangrove.init();



// WEBPACK FOOTER //
// ./library/js/src/global.js